import i18n from './i18n/i18n.js'

export const rules = {
    required: [
        v => !!v || i18n.t("required_field"),
    ],
    required_ipk: [
        v => !!v || i18n.t("required_field"),
        v => (v && (v <= 4 && v > 0)) || i18n.t("max_ipk"),
    ],
    nilai_required: [
        v => !!v || i18n.t("required_field"),
        v => (!isNaN(v) && v >= 1 && v <= 100) || i18n.t("max_100"),
    ],
    required_number_value: [
        v => !!v || i18n.t("required_field"),
        v => (v && v <= 100) || i18n.t("max_100"),
    ],
    required_phone_number: [
        v => !!v || i18n.t("required_field"),
        v => (v && v.length <= 13) || 'Max 13 Character',
    ],
    required_nilai: [
        v => !!v || i18n.t("required_field"),
        v => (v && (v == 'A' || v == 'A-' || v == 'B' || v == 'B+' || v == 'B-' || v == 'C' || v == 'C+' || v == 'C-' || v == 'D')) || i18n.t("format_nilai_tidak_sesuai"),
    ],
    array_required: [
        v => !!v || i18n.t("required_field"),
        v => v.length > 0 || i18n.t("required_field"),
    ],
    url: [
        v => !!v || i18n.t("required_field"),
        v => v.match(new RegExp(/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi)) || i18n.t("input_must_be_url"),
    ]
};